import React, { useEffect, FunctionComponent } from 'react'
import styled from 'styled-components'

interface Props {
    isVisible: boolean
    children?: React.ReactNode
    className?: string
    close?: any
}

const StyledBaseModal = styled.div<Props>`
    .modal-backdrop {
        width: 100%;
        min-height: 100vh;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        overflow: hidden;
        z-index: 1099;
        background: rgba(60, 25, 82, 0.1);
        backdrop-filter: blur(3px);
        opacity: 0;
        will-change: opacity;
        transition: opacity 0.233s cubic-bezier(0, 0, 0.21, 1);
        opacity: ${(props) => props.isVisible && '1'};
        visibility: ${(props) => (props.isVisible ? 'visible' : 'hidden')};
    }

    .modal-container__panel {
        position: relative;
        overflow-y: auto;
        height: 100%;
        min-height: 100vh;
        position: fixed;
        padding: 30px 0;
        left: 0;
        top: 0;
        z-index: 9999;
        right: 0;
        background: none;
        display: flex;
        justify-content: center;
        align-items: center;
        visibility: ${(props) => (props.isVisible ? 'visible' : 'hidden')};

        .modal {
            margin-left: auto;
            margin-right: auto;
            transition: transform 0.3s ease-out;
            transition: -webkit-transform 0.233s cubic-bezier(0, 0, 0.21, 1);
            transition: transform 0.233s cubic-bezier(0, 0, 0.21, 1);
            transition: transform 0.233s cubic-bezier(0, 0, 0.21, 1),
                -webkit-transform 0.233s cubic-bezier(0, 0, 0.21, 1);
            transition: all 0.3s cubic-bezier(0, 0, 0.21, 1);
            opacity: 0;
            outline: none;
            will-change: transform;
            -webkit-transform: scale(1.1);
            transform: scale(1.1);
            background: #ffffff;
            border-radius: 10px;
            z-index: 9999;
            opacity: ${(props) => props.isVisible && '1'};
            transform: ${(props) => props.isVisible && 'scale(1)'};
        }
    }
`

const BaseModal: FunctionComponent<Props> = ({ children, isVisible, close, className }) => {
    useEffect(() => {
        const body: HTMLElement = document.body
        if (isVisible) {
            body.classList.add('overflow-hidden')
        } else {
            body.classList.remove('overflow-hidden')
        }
    }, [isVisible])
    return (
        <StyledBaseModal isVisible={isVisible}>
            <div className='modal-container__panel'>
                <button className='modal-backdrop' onClick={close}></button>
                <div className={`modal ${className}`}>{children}</div>
            </div>
        </StyledBaseModal>
    )
}

export default BaseModal
